import React from "react";
import { Button } from 'antd';
import {Link} from "react-router-dom";
import IntlMessages from "util/IntlMessages";

const ErrorPage = ({ errorCode, errorAction, handleAction }) => (
  <div className="gx-page-error-container">
    <div className="gx-page-error-content">
      <div className="gx-error-code">{errorCode}</div>
      <h2 className="gx-text-center">
        <IntlMessages id={`extraPages.${errorCode}Msg`}/>
      </h2>
      <p className="gx-text-center">
        {
          errorAction ? 
          <Button className="gx-btn gx-btn-primary" onClick={handleAction}><IntlMessages id={`extraPages.${errorAction}`}/></Button> :
          <React.Fragment />
        }
      </p>
    </div>
  </div>
);

ErrorPage.defaultProps = {
  errorCode: "404", 
  errorAction: null, 
  handleAction: null
}

export default ErrorPage;
